import { Navigate, RouteProps } from 'react-router-dom';

import { isLoggedIn } from 'data-layer-cr/dist/authentication';

const PublicOnlyRoute = ({ children }: RouteProps): JSX.Element => {
  const loggedIn = isLoggedIn();
  return !loggedIn ? <>{children}</> : <Navigate to="/" replace />;
};

export default PublicOnlyRoute;
